// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__1P8Mw","small":"styles_small__3iKFb","extra-small":"styles_extra-small__2D4yi"};